// bootstrap-manifest-paths.ts
//
// Phase 06g R2a (security audit 2026-10-12 H3, dogfood 6 F-34, debate N7/B3).
// The bootstrap commit used to stage `"."` — whatever a killed worker left in
// the worktree landed in `[T-0000]`. This is the explicit list of what
// `autopilot init` leaves uncommitted; `run` stages exactly these and stops
// fail-closed on anything else (see `listPathsOutsideManifest`): the next
// tick's `recoverOwnedCheckout` (`reset --hard` + `clean -fd`) would delete
// such a file with no archive, so refusing to run is the only safe answer.
//
// `.claude` covers the pinned pack, `settings.json` and `avatar-tools.json`
// (F-14 — 700+ pack files in the mission branch — is a separate backlog);
// `.claude/state/` is ignored via the mission `.gitignore`, never staged.
export const BOOTSTRAP_MANIFEST_PATHS: readonly string[] = [
  ".avatar/BLUEPRINT.md",
  ".avatar/verification-profile.json",
  ".avatar/tickets",
  ".avatar/PLAN.md",
  ".avatar/plans",
  ".gitignore",
  ".claude",
];

function insideManifest(path: string): boolean {
  return BOOTSTRAP_MANIFEST_PATHS.some((m) => path === m || path.startsWith(`${m}/`));
}

/**
 * Paths outside the manifest from `git status --porcelain --untracked-files=all`
 * output (tracked edits AND untracked files; a rename reports its new name).
 */
export function listPathsOutsideManifest(porcelain: string): string[] {
  const outside: string[] = [];
  for (const line of porcelain.split("\n")) {
    if (line.length < 4) continue;
    const spec = line.slice(3);
    const path = spec.includes(" -> ") ? (spec.split(" -> ").pop() as string) : spec;
    if (!insideManifest(path)) outside.push(path);
  }
  return outside;
}

const SHOWN_PATHS_MAX = 5;

/** Operator-facing reason for the `worktree_dirty` outcome. */
export function describeWorktreeDirty(paths: readonly string[]): string {
  const shown = paths.slice(0, SHOWN_PATHS_MAX).join(", ");
  const more = paths.length > SHOWN_PATHS_MAX ? ` (+${paths.length - SHOWN_PATHS_MAX})` : "";
  return (
    `worktree_dirty: worktree mission có thay đổi ngoài danh sách bootstrap — ${shown}${more}. ` +
    "Tick kế sẽ `reset --hard` + `clean -fd` và XOÁ các file này không archive, nên `run` dừng. " +
    "Giữ chúng: commit tay trên nhánh mission hoặc `git stash` trong worktree, rồi `run` lại."
  );
}
